<template>
    <tab-section title="" :class="{'lam-lower-contrast': !!wizardShown}">
        <template v-slot:information>
            <logs
                :project-id="record.id"
            />
        </template>

        <div class="uk-grid uk-grid-small" data-uk-grid-margin>
            <div class="uk-width-1-3">
                <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                    <div class="uk-width-1-3">
                        <div class="uk-form-controls-text uk-text-bold">Received by</div>
                        <form-select-user
                            id="received_by"
                            name="received_by"
                            :value="record.received_by"
                            :editable="!is_active_locked"
                            :required="false"
                            class="uk-width-1-1"
                            @input="save_field"
                        />
                    </div>
                    <div class="uk-width-2-3">
                        <div class="uk-form-controls-text uk-text-bold">Received by (others)</div>
                        <form-tags-input
                            id="other_receiver_ids"
                            name="other_receiver_ids"
                            entity="user"
                            :value="record.other_receiver_ids"
                            :local-options="filtered_other_receivers"
                            label-field="initials"
                            :editable="!is_active_locked"
                            :required="false"
                            class="uk-width-1-1"
                            @input="save_field"
                        />
                    </div>
                </div>
            </div>
            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Received on</div>
                <form-date-input
                    id="received_at"
                    v-model="record.received_at"
                    name="received_at"
                    :editable="!is_active_locked"
                    :required="false"
                    :error="has_error('is_active_locked')"
                    @input="save_field"
                />
            </div>
            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Received via</div>
                <form-select
                    id="method_of_contact"
                    name="method_of_contact"
                    :value="record.method_of_contact"
                    :options="methods_of_contact"
                    :editable="!is_active_locked"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_field"
                />
            </div>

            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Response by</div>
                <form-select-user
                    id="response_by"
                    name="response_by"
                    :value="record.response_by"
                    :editable="!is_active_locked"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_field"
                />
            </div>
            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Response on</div>
                <form-date-input
                    id="responded_at"
                    v-model="record.responded_at"
                    name="responded_at"
                    :editable="!is_active_locked"
                    :required="false"
                    :error="has_error('responded_at')"
                    @input="save_field"
                />
            </div>
            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Project to be awarded on</div>
                <form-date-input
                    id="projected_awarded_at"
                    v-model="record.projected_awarded_at"
                    name="projected_awarded_at"
                    :min-date="1"
                    :editable="!is_active_locked"
                    :required="false"
                    :error="has_error('projected_awarded_at')"
                    @input="save_field"
                />
            </div>

            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Champion</div>
                <form-select-user
                    id="champion_id"
                    name="champion_id"
                    :value="record.champion_id"
                    empty-label="(Pick one)"
                    :editable="!is_active_locked"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_field"
                />
            </div>
            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Type of Request</div>
                <form-select
                    id="type_of_request"
                    name="type_of_request"
                    :value="record.type_of_request"
                    :options="types_of_request"
                    :editable="!is_active_locked"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_field"
                />
            </div>
            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Insider Knowledge</div>
                <form-select
                    id="insider_knowledge"
                    name="insider_knowledge"
                    :value="record.insider_knowledge"
                    :options="insider_knowledge"
                    :editable="!is_active_locked"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_field"
                />
            </div>
        </div>

        <div class="uk-grid uk-grid-small" data-uk-grid-margin>
            <div class="uk-width-1-1">
                <div class="uk-form-controls-text uk-text-bold">
                    <form-checkbox
                        v-model="record.has_other_teams"
                        name="has_other_teams"
                        :editable="!is_active_locked"
                        @input="save_field"
                    >
                        Other Teams
                    </form-checkbox>
                </div>
                <project-picker
                    v-if="record.has_other_teams"
                    id="other_team_projects"
                    name="other_team_projects"
                    :value="other_team_project_ids"
                    group-field="project_group_id"
                    :editable="!is_active_locked"
                    instructions="(Type-in a project name or nickname, or a firm name)"
                    :horizontal="true"
                    class="uk-margin-bottom"
                    @pick="save_field"
                />

            </div>

            <div v-if="!!is_architect_request" class="uk-width-1-2">
                <form-checkbox
                    id="client_is_considering_others_at_proposal"
                    :value="record.client_is_considering_others_at_proposal"
                    name="client_is_considering_others_at_proposal"
                    :editable="!is_active_locked"
                    @input="save_field"
                >
                    <span class="uk-text-bold">Considering Other Consultants</span>
                </form-checkbox>
            </div>
            <div class="uk-width-1-1 uk-margin-top">
                <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                    <div class="uk-width-1-3">
                        <h4 v-if="record.team_only_deadline" class="uk-text-warning">
                            Team Only (Decide by {{ record.team_only_deadline | nibnut.date("MM/DD/YY") }})
                        </h4>

                        <div class="uk-form-controls-text uk-text-bold">Estimated Fee</div>
                        <form-input
                            id="estimated_fee"
                            v-model="record.estimated_fee"
                            name="estimated_fee"
                            :editable="!is_active_locked"
                            :required="false"
                            :error="has_error('estimated_fee')"
                            @input="save_field"
                        />

                        <div class="uk-form-controls-text uk-text-bold uk-margin-small-top">Primary Deliverable</div>
                        <form-select
                            id="primary_deliverable"
                            name="primary_deliverable"
                            :value="record.primary_deliverable"
                            :options="primary_deliverables"
                            :editable="!is_active_locked"
                            :required="false"
                            class="uk-width-1-1"
                            @input="save_field"
                        />

                        <div v-if="!record.activated_at" class="uk-form-controls-text uk-text-bold uk-margin-small-top">Additional Scope?</div>
                        <project-picker
                            v-if="!record.activated_at"
                            id="activation_scope_number"
                            name="activation_scope_number"
                            :value="record.activation_scope_number"
                            :single-choice="true"
                            id-field="number"
                            instructions="(Type-in a project name, nickname or number)"
                            :horizontal="false"
                            :editable="!is_active_locked"
                            class="uk-width-1-1"
                            @pick="save_field"
                        />
                    </div>
                    <div class="uk-width-1-3">
                        <form-checkbox
                            id="confidential"
                            :value="record.confidential"
                            name="confidential"
                            :editable="!is_active_locked"
                            @input="save_field"
                        >
                            <span class="uk-text-bold">Confidentiality Agreement</span>
                        </form-checkbox>
                        <div v-if="!!record.confidential">
                            <div class="uk-form-controls-text uk-text-bold">Signed</div>
                            <form-date-input
                                id="confidentiality_agreement_signed_at"
                                v-model="record.confidentiality_agreement_signed_at"
                                name="confidentiality_agreement_signed_at"
                                :max-date="0"
                                :editable="!is_active_locked"
                                :required="false"
                                :error="has_error('confidentiality_agreement_signed_at')"
                                @input="save_field"
                            />
                        </div>
                        <div v-if="!!record.confidential">
                            <div class="uk-form-controls-text uk-text-bold">Notes</div>
                            <form-text-area
                                v-if="!is_active_locked"
                                id="confidentiality_agreement_notes"
                                name="confidentiality_agreement_notes"
                                v-model="record.confidentiality_agreement_notes"
                                width="1-1"
                                size="small"
                                :required="false"
                                @input="save_field"
                            />
                            <p v-else-if="!!record.confidentiality_agreement_notes">{{ record.confidentiality_agreement_notes }}</p>
                        </div>

                        <form-checkbox
                            id="pursue"
                            :value="record.pursue"
                            name="pursue"
                            :editable="!is_active_locked"
                            class="uk-margin-small-top"
                            @input="save_field"
                        >
                            <span class="uk-text-bold">Did we pursue?</span>
                        </form-checkbox>

                        <form-checkbox
                            id="extenuating_circumstances"
                            :value="record.extenuating_circumstances"
                            name="extenuating_circumstances"
                            :editable="!is_active_locked"
                            class="uk-margin-small-top"
                            @input="save_field"
                        >
                            <span class="uk-text-bold">Extenuating Circumstances</span>
                        </form-checkbox>
                        <div v-if="!!record.extenuating_circumstances" class="uk-margin-small-top">
                            <div class="uk-form-controls-text uk-text-bold">Notes</div>
                            <form-text-area
                                v-if="!is_active_locked"
                                id="extenuating_circumstances_notes"
                                name="extenuating_circumstances_notes"
                                v-model="record.extenuating_circumstances_notes"
                                width="1-1"
                                size="small"
                                :required="false"
                                @input="save_field"
                            />
                            <p v-else-if="!!record.extenuating_circumstances_notes">{{ record.extenuating_circumstances_notes }}</p>
                        </div>

                        <form-checkbox
                            id="pro_bono"
                            :value="record.pro_bono"
                            name="pro_bono"
                            :editable="!is_active_locked"
                            class="uk-margin-small-top"
                            @input="save_field"
                        >
                            <span class="uk-text-bold">Pro-bono</span>
                        </form-checkbox>
                    </div>
                    <div class="uk-width-1-3">
                        <div class="uk-form-controls-text uk-text-bold">Other Information</div>
                        <form-text-area
                            v-if="!is_active_locked"
                            id="other_info"
                            name="other_info"
                            v-model="record.other_info"
                            width="1-1"
                            size="large"
                            :required="false"
                            @input="save_field"
                        />
                        <p v-else-if="!!record.other_info">{{ record.other_info }}</p>
                    </div>
                </div>
            </div>
        </div>
    </tab-section>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"
import orderBy from "lodash/orderBy"

import is_project_tab_section from "../mixins/IsProjectTabSection"
import project_utilities from "../../../mixins/ProjectUtilities"
import string_utilities from "../../../mixins/StringUtilities"

import FormInput from "../../../ui/FormInput"
import FormTagsInput from "../../../ui/FormTagsInput"
import FormDateInput from "../../../ui/FormDateInput"
import FormSelect from "../../../ui/FormSelect"
import FormSelectUser from "../../../ui/FormSelectUser"
import FormCheckbox from "../../../ui/FormCheckbox"
import FormTextArea from "../../../ui/FormTextArea"
import ProjectPicker from "../../../ui/ProjectPicker"
import Logs from "./Logs"

export default {
    mixins: [is_project_tab_section, project_utilities, string_utilities],
    components: {
        FormInput,
        FormTagsInput,
        FormDateInput,
        FormSelect,
        FormSelectUser,
        FormCheckbox,
        FormTextArea,
        ProjectPicker,
        Logs
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_user_records () {
            return this.$store.getters.entity_records("user")
        },
        raw_project_records () {
            return this.$store.getters.entity_records("project")
        },
        is_active () {
            return this.project_is_active(this.record)
        },
        is_active_locked () {
            if(this.record && this.record.internal) return false
            if(!this.editable || !this.record || !this.profile) return true
            if(this.record.activated_at) { // only the biz or db admin can edit
                if(this.is_administrator || this.is_business_manager || this.is_db_admin_active) return false
                return true
            }
            return !this.editable
        },
        is_architect_request () {
            if(!this.record || !this.record.type_of_request) return false

            const items = this.types_of_request.filter((list_item) => {
                return list_item.id === this.record.type_of_request
            })
            if(!items.length) return false
            return items[0].code_constant === "architect"
        },
        types_of_request () {
            return this.dictionary("type_of_request")
        },
        methods_of_contact () {
            return this.dictionary("method_of_contact")
        },
        insider_knowledge () {
            return this.dictionary("insider_knowledge", "weight")
        },
        primary_deliverables () {
            return orderBy(this.dictionary("primary_deliverable"), "name", "asc")
        },
        other_team_project_ids () {
            if(!this.record || !this.record.project_group_id || !this.record.has_other_teams) return []
            return this.raw_project_records.filter(project => (project.id !== this.record.id) && (project.project_group_id === this.record.project_group_id)).map(project => project.id)
        },
        filtered_other_receivers () {
            if(!this.record) return []
            return orderBy(this.raw_user_records.filter(user => {
                return (user.id !== this.record.champion_id) && !user.deleted_at && !user.currently_on_leave
            }), "initials", "asc")
        }
    }
}
</script>
